import { Flex, Text } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContainer } from "../../components/GlobalContainer";
import { ApiAuth, ApiCall } from "../../_services/api";
import { isSafeInternalPath } from "../../_services/returnTo";
import { SignupForm } from "./signup/SignupForm";

export default function PrivateSignUp() {
  const [location, setLocation] = useState<ReactElement>();
  const [cookies, removeCookie] = useCookies(["token"]);

  const routerLocation = useLocation();
  const navigate = useNavigate();

  const ValidateUser = async (completeWarning = false) => {
    // ApiAuth() já monta o Authorization; o argumento seriam headers extras
    // (passar o token espalhava a string em headers numéricos) — GEN-3199.
    const resp = await new ApiCall("/auth/validate", ApiAuth()).get();

    // O `return` faltava: sem ele, uma resposta de erro seguia para o gate abaixo e disparava um
    // SEGUNDO `navigate("/")` no mesmo tick. Não quebrava nada visível, mas é ruído — e a função
    // foi reescrita aqui de qualquer forma.
    if (resp.status !== 200) {
      navigate("/");
      return;
    }

    // GEN-3658: quem entra aqui é staff da Taxly — e isso é a flag `isTaxlyStaff` do
    // `/auth/validate`, não o sufixo do e-mail. O e-mail é editável pelo próprio dono na tela de
    // Configurações da conta, então a régua antiga abria esta tela para qualquer usuário que
    // trocasse o próprio endereço. A trava real é do backend (as rotas usadas aqui são staff-only);
    // esta é a que evita a tela abrir para quem vai levar 403 em tudo.
    if (!(resp.response as any)?.isTaxlyStaff) {
      navigate("/");
    }
  };

  useEffect(() => {
    ValidateUser();
  }, []);

  useEffect(() => {
    if (routerLocation.hash !== "") {
      const path = (/#!(\/.*)$/.exec(routerLocation.hash) || [])[1];
      // GEN-3167 (deep-review): mesmo atalho legado da tela de Login, mesma guarda — caminho interno
      // segue igual; destino montado para levar a pessoa para fora não navega.
      if (isSafeInternalPath(path)) navigate(path);
    }
  });

  return (
    <GlobalContainer translate="no" display="flex" style={{ backgroundColor: "#f8fafc" }}>
      <Flex id="teste" position="absolute" left="0" top="0" right="0" bottom="0">
        <Flex
          w="60%"
          bgGradient="linear(to-r, #4B4EFF, #5649ff)"
          boxShadow="0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 5px rgba(60,64,67,0.15)"
          justifyContent="center"
          alignItems="center"
        >
          <Text
            color="white"
            fontFamily="Comfortaa"
            fontWeight="800"
            m="0"
            fontSize="120px"
            textShadow="5px 5px #3032c9"
          >
            taxly
          </Text>
        </Flex>
        <Flex w="40%" justifyContent="center" alignItems="center">
          {!location ? <SignupForm locationHandler={setLocation} /> : location}
        </Flex>
      </Flex>
    </GlobalContainer>
  );
}
